import ShiftLeaderIcon from '@mui/icons-material/AccountCircle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import InformationalSection from '~/components/InformationalSection';
import TurnCancellationButton from '~/components/TurnCancellationButton';
import Spacings from '~/modules/ui-kit/spacings';
import { getPhoneNumberUri, toNational } from '~/utils/phone-number-helpers';
import TurnReportButton from './TurnReportButton';
import messages from './messages';

type ShiftLeaderCardProps = {
  currentPublisherIsLeader: boolean;
  shiftLeader: {
    id: number;
    phone: string;
    firstName: string;
    middleName: string;
    lastName: string;
  };
  turn: {
    id: number;
    turnReport?: {
      id: number;
      closed?: boolean;
    };
  };
  shift: {
    id: number;
    startDate: string;
  };
  shiftIsCanceled: boolean;
  submissionDeadlineExceeded: boolean;
  allowTurnLeaderToCancelTurn: boolean;
  settings: {
    masterData: {
      defaultRegionCallingCode: string;
    };
  };
};

const ShiftLeaderCardNonLeader = (
  props: ShiftLeaderCardProps & { children?: ReactNode }
) => {
  return (
    <InformationalSection
      title={<FormattedMessage {...messages.shiftLeader} />}
    >
      <List disablePadding>
        <ListItem
          component={'a'}
          href={getPhoneNumberUri(props.shiftLeader.phone)}
        >
          <ListItemIcon>
            <ShiftLeaderIcon />
          </ListItemIcon>
          <ListItemText
            primary={[
              props.shiftLeader.firstName,
              props.shiftLeader.middleName,
              props.shiftLeader.lastName,
            ].join(' ')}
            secondary={toNational(
              props.shiftLeader.phone,
              props.settings?.masterData?.defaultRegionCallingCode
            )}
          />
        </ListItem>
      </List>
      {props.children}
    </InformationalSection>
  );
};

const ShiftLeaderCardLeader = (props: ShiftLeaderCardProps) => {
  return (
    <ShiftLeaderCardNonLeader {...props}>
      {!props.shiftIsCanceled && (
        <Spacings.Inset>
          <Spacings.Stack alignItems="flexStart">
            {props.allowTurnLeaderToCancelTurn && (
              <TurnCancellationButton
                shiftId={props.shift.id}
                turnId={props.turn.id}
              />
            )}
            <TurnReportButton
              turn={props.turn}
              shift={props.shift}
              submissionDeadlineExceeded={props.submissionDeadlineExceeded}
            />
          </Spacings.Stack>
        </Spacings.Inset>
      )}
    </ShiftLeaderCardNonLeader>
  );
};

export const ShiftLeaderCard = (props: ShiftLeaderCardProps) => {
  return props.currentPublisherIsLeader ? (
    <ShiftLeaderCardLeader {...props} />
  ) : (
    <ShiftLeaderCardNonLeader {...props} />
  );
};

export default ShiftLeaderCard;
